import {useViewjobProctorAllocation} from "../../proctor/__generated__/ViewjobProctorContext";
import {
    RnJsProVjProInsightsTog,
} from "../../proctor/__generated__/ViewjobProctorSpecifications";

export function useIsJsProVjProInsightsTogActive(): boolean {
    const proctorAllocation = useViewjobProctorAllocation(RnJsProVjProInsightsTog);
    return proctorAllocation.value > 0;
}
